import React, { useState, useEffect } from "react";
import { Spinner } from "@blueprintjs/core";
import api from "../../common/lib/api";
import { useError, ErrorState } from "../../common/components/Errors";
import { saveSession } from "../../helpers/session";

export function ApiWrapped({ session, token, endpoint, renderCallback, optional }) {
  const [state, setState] = useState({
    status: "initial",
  });
  const { errors, setErrors, handleError } = useError();
  useEffect(() => {
    async function load() {
      setState({ status: "initial" });
      setErrors([]);
      try {
        api.login(token);
        const { data } = await api.get(endpoint);
        if (session) {
          saveSession(session, {...data, token});
        }
        if (Array.isArray(data)) {
          setState({ data, status: "ready" });
        } else {
          setState({ ...data, status: "ready" });
        }
      } catch (e) {
        if (optional) {
          if (Array.isArray(optional)) {
            setState({ data: optional, status: "ready" });
          } else {
            setState({ ...optional, status: "ready" });
          }
        } else {
          handleError(e);
          setState({ status: "error" });
        }
      }
    }
    load();
  }, [token, setState, setErrors, handleError, endpoint, session, optional]);

  if (state.status === "initial") {
    return (
      <>
        <h1>Loading</h1>
        <Spinner />
      </>
    );
  }
  if (state.status === "error") {
    return <ErrorState errors={errors} />;
  }
  return renderCallback({ state, setState });
}
